import { createActionConst } from '../../../utils/action.utils';

const SESSION_TRANSCRIPT_NAMESPACE = 'SESSION_TRANSCRIPT';

export const STORE_SESSION_TRANSCRIPT = createActionConst(SESSION_TRANSCRIPT_NAMESPACE, 'STORE_SESSION_TRANSCRIPT');
export const CLEAR_SESSION_TRANSCRIPT = createActionConst(SESSION_TRANSCRIPT_NAMESPACE, 'CLEAR_SESSION_TRANSCRIPT');
